import { render } from "./FeedbackBanner.vue?vue&type=template&id=733c129c&scoped=true"
import script from "./FeedbackBanner.vue?vue&type=script&lang=js"
export * from "./FeedbackBanner.vue?vue&type=script&lang=js"

import "./FeedbackBanner.vue?vue&type=style&index=0&id=733c129c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733c129c"]])

export default __exports__